import React from 'react';
export function PinIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.207 1.293l7.5 7.5-1.414 1.414-1.543-1.543-4.816 4.816-1.267 7.601-4.442-4.442-6.046 5.182-1-1 5.182-6.046-4.442-4.442 7.6-1.267 4.817-4.816-1.543-1.543 1.414-1.414zm1.543 4.371l1.586 1.586-5.27 5.27-.733 4.399-5.252-5.252 4.4-.733 5.269-5.27z"
  }));
}